<template>
    <transition name="fade"> 
        <div class="order-exchange-return">
            <!-- 全屏Loading -->
            <div class="fullscreen-loading" v-if="confirm_loading">
                <div class="loading-spinner">
                    <div class="spinner"></div>
                    <div class="loading-desc">处理中,请稍候...</div>
                </div>
            </div>
            <div class="exchange-return-body">
                <Icon type="md-close" @click="close" size="18" class="close-ico" />
                <div class="main-title">驳回申请</div>
                <div class="after-sale-info">
                    <div class="title">售后详情</div>
                    <div class="detail">
                        <div class="detail-item">
                            <div class="label">订单编号：</div>
                            <div class="value">{{order.ord.order_no}}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">售后类型：</div>
                            <div class="value main">{{order.type_name}}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">退货原因：</div>
                            <div class="value">{{order.user_reason}}</div>
                        </div>
                        <div class="detail-item">
                            <div class="label">换新规格：</div>
                            <div class="value">{{order.new_product.name}}({{order.new_product.spec_info}})</div>
                        </div>
                        <div class="img-list" v-viewer>
                            <template v-for="(item,index) in order.user_proof">
                                <img v-if="util.test_image(item)" :src="item|default_img" alt="" class="img-item" :key="`img-${index}`" />
                                <div v-else-if="util.is_video(item)" class="video-wrapper" :key="`video-${index}`" @click.stop="previewVideo(item)">
                                    <img :src="`${item}?x-oss-process=video/snapshot,t_1000,m_fast`" class="img-item" />
                                    <img src="@/assets/images/icon-mall-play.png" class="video-play-icon" />
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="title required">换新规格确认</div>
                    <div class="exchange-spec-box">
                        <img :src="order.new_product.color_image|default_img" alt="" class="products-cover" />
                        <div class="products-info">
                            <div class="products-name">{{order.new_product.name}}</div>
                            <div class="products-spec"><span>{{order.new_product.spec_info}}</span><span>X {{order.goods.quantity}}</span></div>
                        </div>
                    </div>
                    <div class="title required">驳回原因</div>
                    <div class="reject-reason">
                        <Select placeholder="请选择驳回原因" v-model="form.shop_reason">
                            <Option value="超出7天售后期限">超出7天售后期限</Option>
                            <Option value="商品不符合售后标准(吊牌缺失/已使用)">商品不符合售后标准(吊牌缺失/已使用)</Option>
                            <Option value="换货商品无库存(仅换货)">换货商品无库存(仅换货)</Option>
                            <Option value="其它原因">其它原因</Option>
                        </Select>
                    </div>
                    <div class="title">驳回备注(可选)</div>
                    <textarea v-model="form.shop_memo" placeholder="请详细填写驳回原因,方便买家理解"></textarea>
                    <div class="tips">选择驳回原因并填写备注,确认驳回后买家将收到驳回通知</div>
                </div>
                <div class="btn-box">
                    <div class="btn cancel" :class="{ disabled: confirm_loading }" @click="!confirm_loading && close()">取消</div>
                    <div class="btn confirm" :class="{ loading: confirm_loading, disabled: confirm_loading }" @click="onConfirmReject">
                        <span v-if="confirm_loading" class="loading-text">处理中...</span>
                        <span v-else>确定驳回</span>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import { afterSaleApplyReject } from '@/api/index';
import util from '@/utils/util';
export default{
    name:"OrderExchangeReject",
    props:{
        order:{
            type:Object,
            default:()=>{}
        }
    },
    data(){
        return{
           util: util,
           form:{},
           confirm_loading:false
        }
    },
    mounted(){
        this.form.uuid = this.order.uuid;
    },
    beforeDestroy() {
        const mask = document.querySelector('.video-preview-mask');
        if(mask) {
            mask.remove();
        }
    },
    methods:{
        async onConfirmReject(){
            if(this.confirm_loading) return;
            this.confirm_loading = true;
            try{
                const {code,msg} = await afterSaleApplyReject(this.form);
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('操作成功~');
                this.$bus.$emit('list-refresh');
                this.close();
            }catch(e){
                console.log('err-after-sale-apply-reject',e);
                this.$layer.msg('操作失败,请重试');
            }finally{
                this.confirm_loading = false;
            }
        },
        close(){
            this.$emit("close")
        },
        async previewVideo(url){
            const mask = document.createElement('div');
            mask.className = 'video-preview-mask';
            mask.onclick = (e) => {
                if(e.target === mask) this.closeVideoPreview();
            };
            mask.innerHTML = `
                <div class="video-preview-container" onclick="event.stopPropagation()">
                    <div class="video-preview-close" onclick="event.stopPropagation(); this.closest('.video-preview-mask').__vueComponent.closeVideoPreview()">×</div>
                    <div class="video-wrapper-fix">
                        <div class="video-preview-loading">
                            <div class="video-loading-spinner"></div>
                            <span class="video-detect-text">视频文件检测中...</span>
                        </div>
                    </div>
                </div>
            `;
            mask.__vueComponent = this;
            document.body.appendChild(mask);

            const playable = await util.probeVideoPlayable(url);
            if (!mask.parentNode) return;

            const wrapper = mask.querySelector('.video-wrapper-fix');
            if(playable){
                wrapper.innerHTML = `
                    <video src="${url}" controls autoplay class="video-preview" disablePictureInPicture controlsList="nodownload"></video>
                `;
            } else {
                wrapper.innerHTML = `
                    <div class="video-unplayable-box" onclick="event.stopPropagation(); this.closest('.video-preview-mask').__vueComponent.downloadVideo('${url}')">
                        <span class="hint-text">该视频只支持下载预览</span>
                        <span class="download-link">点击下载</span>
                    </div>
                `;
            }
        },
        downloadVideo(url){
            util.downloadVideo(url);
        },
        closeVideoPreview(){
            const mask = document.querySelector('.video-preview-mask');
            if(mask) {
                mask.remove();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.order-exchange-return{
    width:100%;
    height:100%;
    position:fixed;
    top:0;
    left:0;
    background:rgba(0,0,0,0.5);
    display:flex;
    align-items:center;
    justify-content:center;
    z-index:110;
    user-select: none;
    .fullscreen-loading{
        position:fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        z-index:200;
        background:rgba(0,0,0,0.6);
        display:flex;
        align-items:center;
        justify-content:center;
        .loading-spinner{
            display:flex;
            flex-direction:column;
            align-items:center;
            row-gap:16px;
            .spinner{
                width:40px;
                height:40px;
                border:3px solid rgba(255,255,255,0.3);
                border-top-color:#fff;
                border-radius:50%;
                animation:spin 0.8s linear infinite;
            }
            .loading-desc{
                color:#fff;
                font-size:14px;
            }
        }
    }
    @keyframes spin{
        to{transform:rotate(360deg);}
    }
    .exchange-return-body{
        width:508px;
        height:auto;
        max-height:800px;
        // overflow-y:auto;
        position:relative;
        background:#fff;
        border-radius:10px;
        display:flex;
        flex-direction:column;
        .close-ico{
            position:absolute;
            top:14px;
            right:14px;
            cursor:pointer;
        }
        .main-title{
            width:100%;
            text-align:center;
            margin-top:18px;
            padding-bottom:13px;
            font-size:18px;
            font-weight:bold;
            color:#0f1115;
            border-bottom:1px solid #e0e0e0;
        }
        .after-sale-info{
            width:100%;
            flex:1;
            padding:0 24px;
            overflow-y:auto;
            .title{
                color:#333;
                font-size:14px;
                margin-top:13px;
                &.required::after{
                    content:"*";
                    color:red;
                }
            }
            .detail{
                width:100%;
                background:#f6f7f9;
                padding:14px 14px 8px 14px;
                border-radius:6px;
                display:flex;
                flex-direction:column;
                row-gap:9px;
                margin-top:8px;
                .detail-item{
                    width:100%;
                    display:flex;
                    align-items:center;
                    .label{
                        color:#333;
                        font-size:14px;
                    }
                    .value{
                        color:#333;
                        font-size:14px;
                        &.main{
                            color:#ff5967;
                            font-weight:bold;
                        }
                    }
                    .edit-btn{
                        display:flex;
                        align-items:center;
                        padding:0 8px;
                        border:1px solid #e3e3e3;
                        border-radius:4px;
                        column-gap:4px;
                        cursor:pointer;
                        margin-left:16px;
                        .btn-icon{
                            width:16px;
                            height:16px;
                        }
                        .btn-text{
                            color:#666;
                            font-size:12px;
                        }
                    }
                }
                .img-list{
                    display:flex;
                    flex-wrap:wrap;
                    gap:8px;
                    .img-item{
                        width:60px;
                        height:60px;
                    }
                }
                .video-wrapper{
                    position:relative;
                    cursor:pointer;
                    .img-item{
                        width:60px;
                        height:60px;
                        object-fit:cover;
                    }
                    .video-play-icon{
                        position:absolute;
                        top:50%;
                        left:50%;
                        transform:translate(-50%,-50%);
                        width:20px;
                        height:20px;
                        pointer-events:none;
                    }
                }
            }
            .exchange-spec-box{
                width:100%;
                border:1px solid #e3e3e3;
                border-radius:10px;
                padding:16px;
                display:flex;
                column-gap:16px;
                margin-top:8px;
                .products-cover{
                    width:96px;
                    height:96px;
                    border:1px solid #e3e3e3;
                    border-radius:8px;
                }
                .products-info{ 
                    flex:0 0 calc(100% - 96px - 32px);
                    display:flex;
                    flex-direction:column;
                    row-gap:12px;
                    justify-content:center;
                    .products-name{
                        width:100%;
                        display:-webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp:2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        color:#666;
                        font-size:14px;
                    }
                    .products-spec{
                        width:100%;
                        display:flex;
                        column-gap:25px;
                        color:#666;
                        font-size:14px;
                    }
                }
            }
            .reject-reason{
                width:100%;
                margin-top:10px;
            }
            textarea{
                width:100%;
                height:100px;
                border:1px solid #e3e3e3;
                border-radius:4px;
                outline:none;
                padding:12px 16px;
                resize:none;
                margin-top:10px;
            }
            .tips{
                color:#666;
                font-size:12px;
                margin-top:10px;
            }
        }
        .btn-box{
            width:100%;
            display:flex;
            justify-content:center;
            align-items:center;
            column-gap:10px;
            padding-top:14px;
            margin-bottom:27px;
            border-top:1px solid #e3e3e3;
            .btn{
                font-size:14px;
                cursor:pointer;
                font-weight:bold;
                height:40px;
                line-height:40px;
                border-radius:4px;
                &.cancel{
                    color:#666;
                    border:1px solid #e3e3e3;
                    padding:0 36px;
                }
                &.confirm{
                    color:#fff;
                    background:#ff5967;
                    padding:0 34px;
                    &.loading{
                        opacity:0.7;
                        pointer-events:none;
                    }
                    &.disabled{
                        pointer-events:none;
                    }
                }
                &.disabled{
                    opacity:0.5;
                    pointer-events:none;
                }
            }
        }
    }
}
::v-deep .change-money-body{
    width:100%;
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    .label{
        color:#333;
        font-size:14px;
        margin-bottom:10px;
        width:100%;
        text-align:left;
    }
    .value{
        width:100%;
        height:48px;
        border:1px solid #e3e3e3;
        border-radius:4px;
        outline:none;
        padding:0 16px;
    }
}

::v-deep .footer-box{
    width:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    margin-top:20px;
    margin-bottom:40px;
    column-gap:10px;
    .btn{
        font-size:14px;
        cursor:pointer;
        font-weight:bold;
        height:40px;
        line-height:40px;
        border-radius:4px;
        &.cancel{
            color:#666;
            border:1px solid #e3e3e3;
            padding:0 36px;
        }
        &.confirm{
            color:#fff;
            background:#ff5967;
            padding:0 34px;
        }
    }
}

::v-deep .ivu-modal-header{
    border-bottom:none;
}
::v-deep .ivu-modal-footer{
    border-top:none;
}
::v-deep .ivu-modal{
    top:30% !important;
}
</style>
<style lang="scss">
.video-wrapper-fix {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    video {
        max-width: 90vw;
        max-height: 80vh;
    }
    video::-webkit-media-controls-panel {
        display: flex !important;
    }
    video::-webkit-media-controls-overlay-play-button {
        display: none !important;
    }
    video::cue {
        display: none !important;
    }
}
video[controls]::-internal-media-controls-overlay-cast-button,
video[controls]::-webkit-media-controls-overlay-play-button {
    display: none !important;
}
</style>